/*
 * Handles image resizing. Relies heavily on a certain
 * backend folder structure of the file hosting. (wordpress)
 */
window.imgresdone = false;
(function() {
  var rtime = new Date(1, 1, 2000, 12,00,00);
  var timeout = false;
  var delta = 200;
  var imgres = [];

  window.addEventListener('resize', function(event) {
    rtime = new Date();
    if (timeout === false) {
      timeout = true;
      setTimeout(resizeend, delta);
    }
  }, true);

  function resizeend() {
    if (new Date() - rtime < delta) {
      setTimeout(resizeend, delta);
    } else {
      timeout = false;
      checkScreen();
    }
  }

  function init() {
    imgres = document.querySelectorAll('[data-imgres]');
  }

  function checkScreen() {
    // Get Browser Viewport Width
    var newsrc, fullsrc, sizes, maxwidth, maxheight,
        base, ext, safety, newWidth, newHeight, size,
        fullWidth, fullHeight,
        imgWidth, imgHeight, heightTest;
    var windowWidth = window.outerWidth;

    for (var i = imgres.length - 1; i >= 0; i--) {
      if (imgres[i].offsetParent === null) {
        if (imgres[i].getAttribute('data-doimgres') === null) {
          continue;
        }
      }
      newsrc = '';
      sizes = imgres[i].getAttribute('data-sizes');
      if(imgres[i].getAttribute('data-imgres') === 'img') {
        maxwidth = imgres[i].parentNode.offsetWidth;
        maxheight = imgres[i].parentNode.offsetHeight;
      } else {
        maxwidth = imgres[i].offsetWidth;
        maxheight = imgres[i].offsetHeight;
      }

      base = imgres[i].getAttribute('data-base');
      ext = imgres[i].getAttribute('data-ext');
      careAbout = imgres[i].getAttribute('data-careabout');
      safety = 10;
      newWidth = 0;
      newHeight = 0;

/*
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        maxwidth *= window.devicePixelRatio;
        maxheight *= window.devicePixelRatio;
      }*/
      var foundNow = false, foundFull = false;
      fullWidth = 0;
      fullHeight = 0;

      while (sizes.indexOf(')') !== -1 && --safety >= 0) {
        size = sizes.substring(0, sizes.indexOf(')') + 1);
        sizes = sizes.substring(size.length);
        size = size.substring(1, size.length - 1);
        imgWidth = size.substring(0, size.indexOf(','));
        imgHeight = size.substring(imgWidth.length + 1);

        if (!foundNow) {
          heightTest = imgWidth >= maxwidth;

          if (careAbout == 'both') {
            heightTest = (imgWidth >= maxwidth && imgHeight >= maxheight);
          }
          if (careAbout == 'height') {
            heightTest = (imgHeight >= maxheight);
          }

          if (heightTest) {
            newWidth = imgWidth;
            newHeight = imgHeight;
            //safety = 0;
            foundNow = true;
          }
        }

        if (!foundFull && windowWidth <= imgWidth) {
          fullWidth = imgWidth;
          fullHeight = imgHeight;
          foundFull = true;
        }

      }

      if (newWidth && newHeight) {
        newsrc = base + '-' + newWidth + 'x' + newHeight + '.' + ext;
      } else {
        newsrc = base + '.' + ext;
      }

      if (fullWidth && fullHeight) {
        fullsrc = base + '-' + fullWidth + 'x' + fullHeight + '.' + ext;
      } else {
        var fullsizestr = imgres[i].getAttribute('data-fz').split('x');
        fullWidth = fullsizestr[0];
        fullHeight = fullsizestr[1];
        fullsrc = base + '.' + ext;
      }

      if(imgres[i].getAttribute('data-imgres') === 'img') {
        imgres[i].src = newsrc;
      } else {
        imgres[i].style.backgroundImage = 'url("' + newsrc + '")';
      }
    }
  }
  if (!window.dohi) {
    window.dohi = {};
  }
  window.dohi.checkScreen = checkScreen;
  init();
  checkScreen();
  window.imgresdone = true;
})();
